var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenderClosingImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F8512C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4983 10.9962V13.9975",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5022 10.9962V13.9975",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9966,
    y: 12.4969,
    width: 18.0075,
    height: 16.5069,
    rx: 3,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.498 24.0017H21.0003",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3772 24.1267C24.4462 24.1267 24.5022 24.0707 24.5022 24.0017C24.5022 23.9326 24.4462 23.8766 24.3772 23.8766C24.3081 23.8766 24.2521 23.9326 24.2521 24.0017C24.2521 24.0707 24.3081 24.1267 24.3772 24.1267",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5019 20H18.8745",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6233 19.8749C15.5542 19.8749 15.4982 19.9309 15.4982 20C15.4982 20.069 15.5542 20.125 15.6233 20.125C15.6923 20.125 15.7483 20.069 15.7483 20C15.7483 19.9309 15.6923 19.8749 15.6233 19.8749",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenderClosingImage);
export default __webpack_public_path__ + "static/media/TenderClosingImage.baca6cc7ce2d3e6f53204a6879e469e5.svg";
export { ForwardRef as ReactComponent };